import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { isValidElement, cloneElement, Children } from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Label from '../Label';
import Icon from '../Icon';

/**
 * `Badge` component is used for showing small numerical value or status attached to an interface element.
 * @since 0.0.58
 */
var Badge = function Badge(_ref) {
  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "badge") : _ref$baseClassName,
      className = _ref.className,
      children = _ref.children,
      label = _ref.label,
      intent = _ref.intent,
      hidden = _ref.hidden,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "children", "label", "intent", "hidden"]);

  var isAmpty = !label;

  if (Children.toArray(children).length && !hidden) {
    if (!isValidElement(label)) {
      label = React.createElement(Label, {
        intent: "danger"
      }, label);
    }

    if (isValidElement(label)) {
      var cloneProps = {
        className: classNames("".concat(baseClassName, "__value"), _defineProperty({}, "".concat(baseClassName, "__value--dot"), isAmpty), label.props.className)
      };

      if (intent && (label.type === Label || label.type === Icon)) {
        cloneProps.intent = intent;
      }

      label = cloneElement(label, cloneProps);
    }
  } else {
    label = null;
  }

  return React.createElement("div", _extends({
    className: classNames(baseClassName, className)
  }, props), children, label);
};

export default Badge;